import { PersonTypes } from '@frontend/api-person';
import { Avatar, styles, Text } from '@frontend/design-system';
import { IncomingCall } from '../../types';

type Props = {
  incomingCall: IncomingCall;
  image: string | undefined;
  contact: PersonTypes.Person | undefined;
  title: string | undefined;
};

export const IncomingCallBarHead = ({ incomingCall, contact, image, title }: Props) => {
  const initials = incomingCall ? (contact?.FirstName ?? '') + ' ' + (contact?.LastName ?? '') : undefined;
  return (
    <>
      <Avatar name={initials} size='small' title={title} src={image} />
      <Text color='white' css={[styles.truncate, { width: '100%', display: 'block', boxSizing: 'border-box' }]}>
        {title}{' '}
      </Text>
      <Text color='white'>Calling</Text>
    </>
  );
};
